import { render, staticRenderFns } from "./ProductScanner.vue?vue&type=template&id=19772a1c&scoped=true"
import script from "./ProductScanner.vue?vue&type=script&lang=ts"
export * from "./ProductScanner.vue?vue&type=script&lang=ts"
import style0 from "./ProductScanner.vue?vue&type=style&index=0&id=19772a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19772a1c",
  null
  
)

export default component.exports